import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {DATALAKE_EMISSAO_CARACTERISTICAS_PATH} from 'src/utils/api-routes'
import ParameterDatalakeEmissaoCaracteristicasTable
    from 'src/pages/parameters/parameters-datalake/tables/parameter-datalake-emissao-caracteristicas'

const TableEmissaoCaracteristicas = ({loading, cetipIsin}) => {
    const cetip = useMemo(() => {
        if (!cetipIsin) return ''

        // Se for objeto com campo CETIP
        if (typeof cetipIsin === 'object' && cetipIsin.CETIP) {
            return cetipIsin.CETIP.toString().trim()
        }

        // Se já for string simples
        if (typeof cetipIsin === 'string') {
            return cetipIsin.trim()
        }

        return ''
    }, [cetipIsin])

    
    const filters = useMemo(
        () => (cetip ? [{field: 'CETIP__exact', value: cetip}] : []),
        [cetip]
    )

    const tableKey = useMemo(() => `emissao-${cetip || 'all'}`, [cetip])

    return (
        <ParameterDatalakeEmissaoCaracteristicasTable
            key={tableKey}
            customFilter={false}
            disableToolbar
            filters={filters}
            endpoint={`${DATALAKE_EMISSAO_CARACTERISTICAS_PATH}?`}
            loading={loading}
        />
    )
}

TableEmissaoCaracteristicas.propTypes = {
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]), // ajuste conforme seu uso real
    cetipIsin: PropTypes.oneOfType([
        PropTypes.string, 
        PropTypes.shape({
            CETIP: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ]),
}

export default TableEmissaoCaracteristicas